import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { AppComponent } from 'src/app/app.component';
import { NavService } from 'src/app/_services/nav.service';
import { TranslateService } from '@ngx-translate/core';
import { StyleService } from 'src/app/_services/style.service';

const transStyle = `
.prueba {
  transition: none !important;
  content: none !important;
  height: none !important;
  width: none !important;
  /* position: absolute; */
  position: none !important;
  background-image: none !important;
  margin-left: none !important;
  border-radius: none !important;
}`;

@Component({
  selector: 'app-help-page',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class HelpComponent implements OnInit, OnDestroy {
  // tslint:disable-next-line: max-line-length
  constructor(
    private appComponent: AppComponent,
    private navService: NavService,
    private translate: TranslateService,
    public styleService: StyleService
  ) {
    Window['appuser'] = this;
  }

  ngOnInit() {
    // this.authService.isAuthenticated();
    this.appComponent.setTitle('Help');
    this.styleService.addStyle('trans-dialog', transStyle);
    this.selectedNavItem({ parent: null, child: null, notShow: true });
  }

  ngOnDestroy() {
    this.styleService.removeStyle('trans-dialog');
  }

  selectedNavItem(data: any) {
    this.navService.emitNavChangeEvent(data);
  }
}
